import { render, staticRenderFns } from "./partyTopic.vue?vue&type=template&id=705db605&scoped=true"
import script from "./partyTopic.vue?vue&type=script&lang=js"
export * from "./partyTopic.vue?vue&type=script&lang=js"
import style0 from "./partyTopic.vue?vue&type=style&index=0&id=705db605&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705db605",
  null
  
)

export default component.exports